import { memo } from "react";
import { Link } from "react-router-dom";
import { Div, Text, useTheme } from "react-better-html";

import { company } from "../../constants/company";

import { useI18n } from "../../utils/i18n";

function Footer() {
   const theme = useTheme();
   const { t } = useI18n();

   return (
      <Div as="footer" width="100%">
         <Div.column width="100%" alignItems="center" justifyContent="center" gap={theme.styles.gap / 2}>
            <Text fontSize={12} textAlign="center" color={theme.colors.textSecondary + "80"}>
               {t((l) => l.components.footer.productOf, {
                  brandName: () => (
                     <Link to={company.ownerCompany.websiteUrl} target="_blank">
                        <Text as="span" textDecorationHover="underline">
                           {company.ownerCompany.name}
                        </Text>
                     </Link>
                  ),
               })}
            </Text>
            <Text fontSize={12} textAlign="center" color={theme.colors.textSecondary + "80"}>
               {t((l) => l.components.footer.copyright, {
                  brandName: () => company.name,
                  year: () => new Date().getFullYear(),
               })}
            </Text>
         </Div.column>
      </Div>
   );
}

export default memo(Footer);
